export default "__VITE_ASSET__Bvw0kvmS__"